import {Testimonial, Text} from '@primer/react-brand/esm'

import Styles from './Testimonials.module.css'

import type {VisualAsset} from '../../../Index.types'

interface TestimonialStat {
  value: string
  label: string
}

export interface TestimonialsProps {
  a11y: {
    title: string
  }
  items: Array<{
    quote: string
    author: {
      name: string
      position: string
      avatar: VisualAsset
    }
  }>
  stats: [TestimonialStat, TestimonialStat]
}

export const defaultProps: Partial<TestimonialsProps> = {}

export const Testimonials = (props: TestimonialsProps) => {
  const initializedProps: TestimonialsProps = {...defaultProps, ...props}
  const {a11y, items, stats} = initializedProps

  return (
    <div className={Styles.Testimonials}>
      <h2 className="visually-hidden">{a11y.title}</h2>
      <div className={Styles.Testimonials__quotes}>
        {/* TODO: Render all quotes when Primer Brand supports multiple testimonials with embedded pagination. */}
        {items.slice(0, 1).map(({quote, author}) => (
          <Testimonial key={quote} variant="minimal" size="large" quoteMarkColor="green">
            <Testimonial.Quote>{quote}</Testimonial.Quote>
            <Testimonial.Avatar src={author.avatar.url} alt="" width={48} height={48} loading="lazy" />
            <Testimonial.Name position={author.position}>{author.name}</Testimonial.Name>
          </Testimonial>
        ))}
      </div>
      <div className={Styles.Testimonials__stats}>
        {stats.map(({value, label}) => (
          <div className={Styles.Testimonials__stat} key={label}>
            <Text as="p" size="600" font="monospace" hasAntiAliasing={false} className={Styles.Testimonials__statValue}>
              {value}
            </Text>
            <Text as="p" size="100" font="monospace" variant="muted">
              {label}
            </Text>
          </div>
        ))}
      </div>
    </div>
  )
}
